<template>
  <div class="login-form">
    <div class="login-form__wrapper">
      <AppHeading tag="h2" text="Login" class="form__title" />
      <AppHeading tag="span" :text="$t('pages.login.welcome')" class="form__subtitle" />
      <!-- FORM -->
      <AppForm @submit.prevent class="form__form">
        <!-- username -->
        <AppInput
          id="loggin-user-name"
          v-model="userInfo.username"
          class="form__input"
          :label="$t('forms.placeholders.user')"
          :floating-label="false"
          prepend-icon="fas fa-user"
          autocomplete="off"
          :disabled="sendingData"
        />
        <!-- password -->
        <AppInput
          id="loggin-password"
          v-model="userInfo.password"
          class="form__input"
          :label="$t('forms.placeholders.password')"
          :floating-label="false"
          prepend-icon="fas fa-lock-alt"
          autocomplete="off"
          :disabled="sendingData"
          :type="showPassword ? 'text' : 'password'"
          :append-icon="showPassword ? 'fal fa-eye' : 'fal fa-eye-slash'"
          @click:append="showPassword = !showPassword"
        />
        <div class="app-form__actions">
          <!-- remember user -->
          <AppCheckbox
            id="remember-user"
            v-model="userInfo.remember"
            :label="$t('forms.placeholders.remember_me')"
            :disabled="sendingData"
          />
          <!-- forgot password -->
          <AppRouterLink
            class="form__back-link login"
            exact
            :to="{ name: 'forgot-password' }"
            :text="$t('forms.label.forgot_password')"
          />
        </div>
        <!-- submit -->
        <SubmitButtonMagenta
          id="loggin-button"
          :loading="sendingData"
          :disabled="!hasData"
          type="submit"
          spinner-color="#fff"
          @click="login"
        >
          {{ $t('ui.buttons.login') }}
        </SubmitButtonMagenta>
      </AppForm>
    </div>
  </div>
</template>

<script>
// Utils
import Nprogress from 'nprogress'
import { networkErrorPage } from 'Router/helpers'
import { Notification } from 'Utils/Classes/Notification'
// Components
import AppInput from 'Ui/AppInput'
import AppHeading from 'Ui/AppHeading'
import AppCheckbox from 'Ui/AppCheckbox'
import AppForm from 'Components/AppForm'
import AppRouterLink from 'Ui/AppRouterLink'
import SubmitButtonMagenta from 'Components/SubmitButtonMagenta'

export default {
  name: 'LoginForm',

  components: {
    AppForm,
    AppInput,
    AppHeading,
    AppCheckbox,
    AppRouterLink,
    SubmitButtonMagenta,
  },

  data() {
    return {
      showPassword: false,
      sendingData: false,
      userInfo: {
        username: '',
        password: '',
        remember: false,
      },
    }
  },

  methods: {
    resetData() {
      this.userInfo = {
        username: '',
        password: '',
        remember: false,
      }
    },

    async login() {
      const notification = new Notification()
      this.sendingData = true
      try {
        Nprogress.start()
        const user = await this.$store.dispatch('user/login', this.userInfo)
        // Preparing notification
        notification.type = 'info'
        notification.icon = false
        notification.message = this.$t('ui.notifications.greeting', { name: user.first_name })
        // Redirecting
        notification.dispatch()
        Nprogress.done()
        // checking for possible redirections
        const hasQuery = Object.keys(this.$route.query).length !== 0
        const redirect_url = hasQuery ? { path: this.$route.query } : { name: 'dashboard' }
        this.$router.push(redirect_url)
      } catch (error) {
        if (!error.response) {
          this.$router.push(networkErrorPage)
          this.resetData()
        }
        Nprogress.done()
        this.sendingData = false
      }
    },
  },

  computed: {
    hasData() {
      return this.userInfo.username !== '' && this.userInfo.password !== ''
    },
  },
}
</script>

<style scoped src="@/assets/css/shared-styles/login-forms.css"></style>
<style scoped></style>
